'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _css = require('antd/lib/input/style/css');

var _input = require('antd/lib/input');

var _input2 = _interopRequireDefault(_input);

var _css2 = require('antd/lib/form/style/css');

var _form = require('antd/lib/form');

var _form2 = _interopRequireDefault(_form);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /**
                                                                                                                                                                                                                                                                   * 发货按钮及弹出表单：同城速配
                                                                                                                                                                                                                                                                   */


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _modal_form = require('./modal_form');

var _modal_form2 = _interopRequireDefault(_modal_form);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FormItem = _form2.default.Item;

var ShipLocal = _react2.default.createClass({
    displayName: 'ShipLocal',
    onOk: function onOk(form) {

        return Promise.resolve();
    },
    render: function render() {
        var _props = this.props,
            order = _props.order,
            form = _props.form;
        var getFieldDecorator = form.getFieldDecorator;

        var formItemLayout = {
            labelCol: { span: 6 },
            wrapperCol: { span: 14 }
        };
        return _react2.default.createElement(
            _modal_form2.default,
            { form: form, onOk: this.onOk.bind(this, form), title: '\u53D1\u8D27' },
            _react2.default.createElement(
                _form2.default,
                null,
                _react2.default.createElement(
                    FormItem,
                    _extends({}, formItemLayout, { label: '\u53D1\u8D27\u65B9\u5F0F' }),
                    _react2.default.createElement(
                        'span',
                        null,
                        order.ship.type
                    )
                ),
                _react2.default.createElement(
                    FormItem,
                    _extends({}, formItemLayout, { required: true, label: '\u9001\u8D27\u4EBA' }),
                    getFieldDecorator('courier', {
                        rules: [{ required: true, message: '请输入送货人姓名!' }]
                    })(_react2.default.createElement(_input2.default, { type: 'text' }))
                ),
                _react2.default.createElement(
                    FormItem,
                    _extends({}, formItemLayout, { required: true, label: '\u8054\u7CFB\u7535\u8BDD' }),
                    getFieldDecorator('mobile', {
                        rules: [{ required: true, message: '请输入送货人联系电话!' }]
                    })(_react2.default.createElement(_input2.default, { type: 'text' }))
                ),
                _react2.default.createElement(
                    FormItem,
                    _extends({}, formItemLayout, { label: '\u5907\u6CE8' }),
                    getFieldDecorator('note')(_react2.default.createElement(_input2.default, { type: 'textarea' }))
                )
            )
        );
    }
});

exports.default = _form2.default.create()(ShipLocal);


//////////////////
// WEBPACK FOOTER
// ./src/js/components/ship_local.js
// module id = 1314
// module chunks = 0